import React, { useState, useEffect } from 'react';
// eslint-disable-next-line import/no-unresolved
import { useHistory } from 'react-router-dom';

import Input from '../../../components/Inputs/Input';
import logo from '../../../assets/logo_GNDI.svg';

import masks from '../../../utils/masks.json';

import { useGlobal } from '../../../contexts/Global/context';

import {
    getGruposContratoAndContratosByContractNumber,
    getGruposContratoAndContratosByCpfCnpj,
} from '../../../services';

import * as S from './styles';
import { getFormattedContractLoginData } from '../../../utils/getFormattedContractLoginData';
// import Loading from '../../../components/Loading';
import Button from '../../../components/Button';
import { addMaskCpf, addMaskCnpj } from '../../../utils/formatValues';
import { getToken } from '../../../utils/auth';

export const AutenticacaoSuporte = ({
    setLoadingGroupContracts,
    setSuportDocument,
    setSuportFlow,
    setAuthorizationState,
}) => {
    const {
        setContractsList,
        setContractsGroupsList,
        dataLogin,
        setDataActiveContract,
        setStaticOptions,
        setDataLogin,
    } = useGlobal();

    const history = useHistory();

    const [errorWarning, setErrorWarning] = useState('');
    const [loadingButton, setLoadingButton] = useState(false);
    const [searchCpfAndCnpj, setSetCpfAndCnpj] = useState({
        id: 'cpfAndCnpj',
        placeholder: 'CNPJ ou CPF',
        required: false,
        type: 'text',
        error: '',
        value: '',
    });

    const [searchContractNumber, setSearchContractNumber] = useState({
        id: 'contractNumber',
        placeholder: 'Nº de contrato',
        required: false,
        mask: masks.contractNumber,
        type: 'text',
        error: '',
        value: '',
    });

    const [HAS_TOKEN] = getToken();
    useEffect(() => {
        if (!HAS_TOKEN) {
            setTimeout(() => {
                window.location = 'https://ri.gndi.com.br/';
            }, 6000);
        }
    }, []);

    async function validateContractNumber(value) {
        const response = await getGruposContratoAndContratosByContractNumber(value);

        if (response.length >= 1) {
            const { formattedContract, profileData, staticOptions } = await getFormattedContractLoginData({
                contract: { numeroContrato: value },
                email: dataLogin.email,
            });

            setDataActiveContract(formattedContract);

            setStaticOptions(staticOptions);

            setDataLogin({ ...dataLogin, ...profileData });

            setAuthorizationState({ grupoContratoSelecionado: true, contratoSelecionado: false, autenticado: true });

            setSuportDocument({ field: 'número de contrato', value });

            setContractsGroupsList(response);

            setContractsList(response[0]?.contratos);

            setLoadingGroupContracts(false);

            setSuportFlow({ step: 2 });

            history.push({
                pathname: '/',
            });
        } else {
            setErrorWarning('O número de contrato informado é inválido.');
        }

        return response;
    }

    function handleChangeCpfCnpj(event) {
        const onlyNumbers = event.value.replace(/\D/g, '');

        // Size of CNPJ value
        if (onlyNumbers.length > 14) return;

        const maskedValue = onlyNumbers.length <= 11 ? addMaskCpf(onlyNumbers) : addMaskCnpj(onlyNumbers);

        setSetCpfAndCnpj({
            ...searchCpfAndCnpj,
            value: maskedValue,
            unmaskedValue: onlyNumbers,
        });
    }

    async function validateDocuments(value) {
        const response = await getGruposContratoAndContratosByCpfCnpj(value);
        if (response.length >= 1) {
            setSuportDocument({ field: 'CPF/CNPJ', value });
            setContractsGroupsList(response);
            setSuportFlow({ step: 2 });
            history.push({
                pathname: '/selecao_contrato',
            });
        } else {
            setErrorWarning('O CNPJ/CPF informado é inválido ou a empresa está inativa.');
        }
        return response;
    }

    async function handleInputBlur() {
        setLoadingButton(true);

        if (searchCpfAndCnpj.value === '' && searchContractNumber.value === '') {
            setErrorWarning('Insira dados para continuar');
            searchContractNumber.error = true;
            searchCpfAndCnpj.error = true;
            return;
            // eslint-disable-next-line no-else-return
        } else {
            setErrorWarning('');
            searchContractNumber.error = false;
            searchCpfAndCnpj.error = false;
        }

        if (searchCpfAndCnpj.value !== '') {
            await validateDocuments(searchCpfAndCnpj.unmaskedValue);
        }

        if (searchContractNumber.value !== '') {
            await validateContractNumber(searchContractNumber.value);
        }

        setLoadingButton(false);
    }

    return (
        <S.Container>
            <S.ContainerCard>
                <S.Logo>
                    <img src={logo} width={186} alt="logo notredame intermédica" />
                </S.Logo>

                {!HAS_TOKEN ? (
                    <>
                        <S.Title>
                            Para acessar a área de suporte, encerre sua sessão atual e faça login novamente.
                        </S.Title>
                        <S.SubTitle>
                            Você será automaticamente redirecionado para o portal Institucional dentro de alguns
                            segundos...
                        </S.SubTitle>
                    </>
                ) : (
                    <>
                        <S.Title>Acesso de suporte à empresa</S.Title>
                        <S.SubTitle>Preencha um dos campos para acessar a área logada da empresa</S.SubTitle>
                        <S.Error>{errorWarning}</S.Error>
                        <Input
                            field={searchCpfAndCnpj}
                            stylesGroup={{
                                margin: 0,
                            }}
                            onChange={(event) => handleChangeCpfCnpj(event)}
                        />
                        <S.Divider>
                            <S.LineDivider />
                            <S.Text>ou</S.Text>
                            <S.LineDivider />
                        </S.Divider>
                        <Input
                            field={searchContractNumber}
                            stylesGroup={{
                                margin: 0,
                            }}
                            onChange={(event) =>
                                setSearchContractNumber({ ...searchContractNumber, value: event.unmaskedValue })
                            }
                        />

                        <Button
                            style={{ width: '100%', marginBottom: 35 }}
                            loading={loadingButton}
                            disabled={loadingButton}
                            onClick={(event) => handleInputBlur(event)}
                        >
                            Continuar
                        </Button>
                    </>
                )}
            </S.ContainerCard>
        </S.Container>
    );
};
